// src/services/adminStadiumService.ts

import apiClient from "./apiClient";
import {
  AdminStadiumModel,
  CreateAdminStadiumRequest,
  UpdateAdminStadiumRequest,
} from "../models/AdminStadiumModel";
import { PageResponse } from "../models/PaginationModel";

const BASE_URL = "/api/admin/stadiums";

export interface AdminStadiumFilters {
  search: string;
  country: string;
  active: "" | "true" | "false";
  isPrimary: "" | "true" | "false";
  teamId: string;
  sortBy: string;
  sortDir: "asc" | "desc";
}

export const getAdminStadiums = async (
  page: number,
  pageSize: number,
  filters: AdminStadiumFilters
): Promise<{ content: AdminStadiumModel[]; totalPages: number; totalItems: number }> => {
  const params = new URLSearchParams({
    page:    String(page),
    size:    String(pageSize),
    sortBy:  filters.sortBy  || "name",
    sortDir: filters.sortDir || "asc",
  });
  if (filters.search.trim())    params.set("search",    filters.search.trim());
  if (filters.country)          params.set("country",   filters.country);
  if (filters.active !== "")    params.set("active",    filters.active);
  if (filters.isPrimary !== "") params.set("isPrimary", filters.isPrimary);
  if (filters.teamId)           params.set("teamId",    filters.teamId);

  const response = await apiClient.get<PageResponse<AdminStadiumModel>>(`${BASE_URL}?${params.toString()}`);
  return {
    content:    response.content    ?? [],
    totalPages: response.totalPages ?? 1,
    totalItems: response.totalItems ?? response.content?.length ?? 0,
  };
};

export const getAdminStadiumById = (id: number): Promise<AdminStadiumModel> =>
  apiClient.get<AdminStadiumModel>(`${BASE_URL}/${id}`);

export const createAdminStadium = (data: CreateAdminStadiumRequest): Promise<AdminStadiumModel> =>
  apiClient.post<AdminStadiumModel>(BASE_URL, data);

export const updateAdminStadium = (id: number, data: UpdateAdminStadiumRequest): Promise<AdminStadiumModel> =>
  apiClient.put<AdminStadiumModel>(`${BASE_URL}/${id}`, data);

export const deleteAdminStadium = (id: number): Promise<void> =>
  apiClient.delete<void>(`${BASE_URL}/${id}`);

export const toggleStadiumActive = (id: number, active: boolean): Promise<AdminStadiumModel> =>
  apiClient.put<AdminStadiumModel>(`${BASE_URL}/${id}`, { active });